export default [
  {
    path: "/index",
    name: "index",
    component: () => import("@/views/Layout/Layout.vue"),
    meta: {
      title: "首页",
      icon: "el-icon-House",
      levelHidden: true,
    },
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/Home.vue"),
        meta: {
          title: "首页",
          icon: "el-icon-House",
        },
      },
    ],
  },
  {
    path: "/PassWord",
    name: "PassWord",
    redirect: "/EditPassWord",
    hidden: true,
    component: () => import("@/views/Layout/Layout.vue"),
    meta: {
      title: "修改密码",
    },
    children: [
      {
        path: "/EditPassWord",
        name: "EditPassWord",
        component: () => import("@/views/PassWord/index.vue"),
        meta: {
          title: "修改密码",
          icon: "Edit",
        },
      },
    ],
  },
];